'use strict';

/**
 * If pageProps not specified, google analytics could still
 * pick up page's title and location.
 */
function createGApageview() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unknown page';
  var pageProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var defaultPageView = {
    event: 'REDUX_GTM_GA_EVENT',
    hitType: 'pageview',
    page: page
  };
  return Object.assign(defaultPageView, pageProps);
}

module.exports = createGApageview;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-gtm/lib/event-helpers/create-ga-pageview.js
// module id = 337
// module chunks = 0